export type ClassName =
  | string
  | string[]
  | Record<string, boolean | undefined>
  | undefined;
export function mergeClasses(...classes: ClassName[]) {
  const class_list: string[] = [];
  for (const c of classes) {
    if (!c) continue;
    if (typeof c === 'string') class_list.push(c);
    else if (Array.isArray(c)) {
      class_list.push(...c.filter(Boolean));
    } else if (typeof c === 'object') {
      for (const k in c) {
        if (c[k]) class_list.push(k);
      }
    }
  }
  return class_list.join(' ');
}
